import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { hideDinnerSuggestionsPreferencesPopup } from "@app/store/app/appActions"
import { RootState } from "@app/types"
import DrawerPopup from "@modules/popup/DrawerPopup"
import DinnerSuggestionsPreferences from "@modules/user/DinnerSuggestionsPreferences"

const DinnerSuggestionsPreferencesDrawer = () => {
    const dispatch = useDispatch<any>()
    const isOpen = useSelector(
        (state: RootState) => state.app.dinnerSuggestionsPreferencesPopup.visible,
    )
    const handleClose = () => dispatch(hideDinnerSuggestionsPreferencesPopup())

    return (
        <DrawerPopup
            className="dinner-suggestions-popup-modal dinner-suggestions-preferences-modal"
            drawerSize="tall"
            isOpen={isOpen}
            isTitleHidden
            onClose={handleClose}
            title="Preferanser for middagsforslag"
        >
            <DinnerSuggestionsPreferences onClose={handleClose} />
        </DrawerPopup>
    )
}

export default DinnerSuggestionsPreferencesDrawer
